import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { Link } from '@atlassian/react-resource-router';

export const itemWidthGridUnits = 34;
const itemHeightGridUnits = 36;
export const headerHeightGridUnits = itemHeightGridUnits / 2;
const borderRadiusPx = '3px';

const containerCommon = {
	borderRadius: borderRadiusPx,
	boxShadow: `0 0 0.5px 0 ${token(
		'color.background.neutral.hovered',
		colors.N100,
	)}, 0 1px 1px 0 ${token('color.background.neutral.hovered', colors.N50)}`,
	display: 'flex',
	flexDirection: 'column',
	height: `${gridSize * itemHeightGridUnits}px`,
	maxHeight: `${gridSize * itemHeightGridUnits}px`,
	width: `${gridSize * itemWidthGridUnits}px` /* required for IE11 */,
	maxWidth: `${gridSize * itemWidthGridUnits}px`,
};

const EnabledContainerMixin = {
	...containerCommon,
	color: 'inherit',
	textDecoration: 'none',
	transition: 'box-shadow 0.2s ease-in-out',
	'&:hover, &:active': {
		color: 'inherit',
		textDecoration: 'none',
		boxShadow: `0 4px 8px 0 ${token(
			'color.background.neutral.pressed',
			'#b3bac5',
		)}, 0 0 1px 0 ${token('color.background.neutral.pressed', '#b3bac5')}`,
	},

	'&:focus': {
		outline: 'none',
	},
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const EnabledLinkContainer = styled(Link)(EnabledContainerMixin);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DisabledContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	...containerCommon,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.disabled', colors.N300),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Header = styled.div({
	borderTopLeftRadius: borderRadiusPx,
	borderTopRightRadius: borderRadiusPx,
	overflow: 'hidden',
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * headerHeightGridUnits}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	maxHeight: `${gridSize * headerHeightGridUnits}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ReasonWrapper = styled.div({
	cursor: 'default',
	position: 'absolute',
	bottom: token('space.200', '16px'),
	right: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Body = styled.div({});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TextWrapper = styled.div({
	padding: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = styled.p({
	fontWeight: 'bold',
	marginTop: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Description = styled.p({
	marginTop: token('space.100', '8px'),
});
